/**
 * @module use-cases/content/actions
 * @desc Content Action Creators
 *
 */

import { createAction, createAsyncAction } from 'core/use-cases/utilities';

import type { Content, StarlinkDocumentPageName, ContentEntity } from 'core/domains';

export const starlinkPageFetch = createAsyncAction<
  'starlinkPageFetch',
  StarlinkDocumentPageName,
  ContentEntity['data'],
  StarlinkDocumentPageName
>('starlinkPageFetch');

export const starlinkContentFetch = createAsyncAction<
  'starlinkContentFetch',
  StarlinkDocumentPageName,
  ContentEntity['data'],
  StarlinkDocumentPageName
>('starlinkContentFetch');

export const contentCleanUp = createAction<'contentCleanUp', string>('contentCleanUp');

export const contentFetch = createAsyncAction<
  'contentFetch',
  string,
  Content[number]['data'],
  string
>('contentFetch');
